import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export class KsefRefreshConfigurationStatusCommand extends Command<null, boolean> {}

export class KsefRefreshConfigurationStatusCommandBase implements CommandHandler<KsefRefreshConfigurationStatusCommand, null, boolean> {
	private static Url = TaggedUrl.join('myCompany/ksef/refresh', [Tags.Api]);

	public constructor(
		private readonly http: HttpService
	) { }

	public async handleAsync(_: KsefRefreshConfigurationStatusCommand): Promise<boolean> {
		return await this.http.post(KsefRefreshConfigurationStatusCommandBase.Url).then(() => true, () => false);
	}
}
